import React from 'react'
import { useTranslation } from 'react-i18next'
import IWPageHeader, {
  StyledTitle,
} from 'shared/components/thunderbolt/IWPageHeader'
import IWButton from 'shared/components/thunderbolt/IWButton'
import { FullPageMainContent, OverlayPage } from 'root/components/IWLayout'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import LSIBTSubmitWizard from '../components/LSIBTSubmitWizard'
import IWSpacer from 'shared/components/thunderbolt/IWSpacer'

const StyledCaretIcon = styled(FontAwesomeIcon)`
  align-self: center;
  font-size: 1rem;
  color: ${(props) => props.theme.palette.grey[400]};
`

const StyledWrapper = styled.div`
  max-width: ${(props) => props.theme.dimensions.maxScreenWidth};
  display: flex;
  flex: 1;
  gap: 0.5rem;
  align-items: center;
  align-content: center;
  justify-content: space-between;
`

const LoadSchedulingIBTSubmit = () => {
  const { t } = useTranslation()
  return (
    <OverlayPage>
      <IWPageHeader data-testid="page-header" isFullScreen>
        <StyledWrapper>
          <StyledTitle>{t('loadScheduling.loadScheduling')}</StyledTitle>
          <StyledCaretIcon icon={faChevronRight} />
          <StyledTitle>
            {t('loadScheduling.titles.internalBilaterals')}
          </StyledTitle>
          <IWSpacer />
          <IWButton
            as="routerNavLink"
            to="/"
            variant="alternative"
            color="primary"
            data-testid="page-header-close-button"
          >
            {t('button.close')}
          </IWButton>
        </StyledWrapper>
      </IWPageHeader>
      <FullPageMainContent>
        <LSIBTSubmitWizard />
      </FullPageMainContent>
    </OverlayPage>
  )
}

export default LoadSchedulingIBTSubmit
